<template>
  <div>
    <div
      class="flex flex-row justify-between items-center mb-4 bg-white shadow-sm sm:rounded-t-md py-6 px-4 sm:px-6 lg:px-8"
    >
      <AnalyticsDateRangePicker v-model="dateRange" :placeholder="t('select_period')" />
    </div>

    <div v-if="isLoading" class="flex justify-center items-center">
      <Loading />
    </div>
    <SellerAnalytics
      v-else-if="stats"
      :currentMonth="currentMonthLabel"
      :stats="stats"
      :total="total"
      :showGrossSalesCount="hasSeatsOrFurniture"
    />
  </div>
</template>

<script>
import { AnalyticsDateRangePicker, Loading, currentMonthRange, inputDateFormat } from "@estaly/ui";
import SellerAnalytics from "@/components/analytics/retail/SellerAnalytics.vue";
import AnalyticsService from "@/api/services/analytics";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { mapGetters } from "vuex";
import { useI18n } from "vue-i18n";

export default {
  components: {
    AnalyticsDateRangePicker,
    SellerAnalytics,
    Loading,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data: () => ({
    isLoading: false,
    dateRange: currentMonthRange().map((date) => inputDateFormat(date)),
    currentMonthLabel: "",
    stats: null,
    total: null,
  }),

  computed: {
    ...mapGetters("store", ["selectedStoreId"]),
    ...mapGetters("businessVerticals", ["hasSeatsOrFurniture"]),
  },

  methods: {
    updateCurrentMonth(endDate) {
      const formattedMonth = format(new Date(endDate), "MMMM yyyy", { locale: fr });
      this.currentMonthLabel = formattedMonth.charAt(0).toUpperCase() + formattedMonth.slice(1);
    },

    async fetchSellersData() {
      if (!this.selectedStoreId) return;

      this.isLoading = true;
      const response = await AnalyticsService.getRetailSellersData(
        this.selectedStoreId,
        this.dateRange[0],
        this.dateRange[1],
        this.hasSeatsOrFurniture ? "gross_sales_count" : null,
      );
      this.isLoading = false;

      if (response?.success) {
        this.stats = response.data.stats;
        this.total = response.data.total;
      }
    },
  },

  watch: {
    dateRange: {
      immediate: true,
      handler(newDate) {
        if (!Array.isArray(newDate) || !newDate[0] || !newDate[1]) return;
        this.updateCurrentMonth(newDate[1]);
        this.fetchSellersData();
      },
    },
  },
};
</script>

<i18n src="./PosPilotage.i18n.json"></i18n>
